import { render, staticRenderFns } from "./alt-ios-native-select.vue?vue&type=template&id=4696deb8&scoped=true"
import script from "./alt-ios-native-select.vue?vue&type=script&lang=js"
export * from "./alt-ios-native-select.vue?vue&type=script&lang=js"
import style0 from "./alt-ios-native-select.vue?vue&type=style&index=0&id=4696deb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4696deb8",
  null
  
)

export default component.exports